class DataEntity {
  constructor(data) {
    this.response = data;
  }

  getItems() {
    return this.response?.data || [];
  }

  getData() {
    return this.response?.data || {};
  }

  isEmpty() {
    if (!(this.data instanceof Object)) {
      return false;
    }
    
    if (typeof this.response.data === 'undefined') {
      return true;
    }
    if (typeof this.response.data === 'object' && this.response.data !== null) {
      return Object.keys(this.response.data).length <= 0;
    }
    return this.response.data.length <= 0;
  }

  isNotEmpty() {
    return !this.isEmpty();
  }
}

export default DataEntity;
